import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';

const InputTypography = css`
  vertical-align: middle;
  text-align: center;
  ${TYPOGRAPHY.CIRCULAR.book}
  color: ${BRAND_COLORS.black};
  font-size: 16px;
  line-height: 24px;
`;

interface CodeInputWrapperProps {
  $isLoading?: boolean;
}

export const CodeInputWrapper = styled.div<CodeInputWrapperProps>`
  display: grid;
  width: min-content;
`;

export const SegmentsWrapper = styled.div`
  grid-area: 1 / 1 / 2 / 2;

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  column-gap: 8px;

  width: fit-content;
`;

interface HiddenInputProps {
  $isLoading?: boolean;
  maxLength: number;
  value: string;
}

export const HiddenInput = styled.input.attrs<HiddenInputProps>(({ $isLoading }) => ({
  name: 'otp',
  'aria-label': 'Verification code',
  autoComplete: 'one-time-code',
  'data-1p-ignore': 'true',
  inputMode: 'numeric',
  autoFocus: true,
  type: 'text',
  disabled: Boolean($isLoading),
}))`
  grid-area: 1 / 1 / 2 / 2;

  min-width: 0;
  padding: 12px;

  ${InputTypography}

  /* These magic values line up the digits perfectly with the Segments
   in order to have the correct position for the caret */
  letter-spacing: 47.5px;
  text-indent: 9px;
  text-align: left;

  caret-color: ${BRAND_COLORS.black};
  /* Hide caret when the form is loading */
  ${({ $isLoading }) => $isLoading && css`
    caret-color: transparent;
  `}

  color: transparent;
  background: 0;
  border: none;
  && {
    &:focus-visible {
      outline: none;
    }
  }

  &::selection {
    color: transparent;
    background-color: transparent;
  }
`;

interface SegmentProps {
  $isFocused?: boolean;
}
export const Segment = styled.div<SegmentProps>`
  ${InputTypography}

  padding: 12px;

  width: 48px;
  height: 48px;

  border-radius: 8px;
  outline-style: solid;
  outline-width: ${({ $isFocused }) => $isFocused
    ? '2px'
    : '1px'};
  outline-color: ${({ $isFocused }) => $isFocused
    ? BRAND_COLORS.darkGreen
    : BRAND_COLORS.darkStroke};

  transition-property: outline-width, outline-color;
  transition-duration: 150ms;
`;
